// query

export const avatarQueryKeys = {
  AVATAR_IMAGE: 'avatar-image'
}
